import React, { Fragment } from 'react'


const Filter = ({ id, register, handleSubmit, onReset, types = [], filters }) => {

  return (
    <form className="map__filter" onSubmit={handleSubmit}>
      <div className="map__filter-fields">
        <div className="map__filter-field">
          <input type="text" placeholder="Search" {...register('keywords', {
            value: filters.keywords
          })} inputMode="search" id={`keywords__${id}`} />
          <label htmlFor={`keywords__${id}`}>Search by title or keyword</label>
        </div>
      </div>

      <div className="map__filter-buttons">
        <button type="submit">Submit</button>
        <button type="button" onClick={onReset}>Reset</button>
      </div>
    </form>
  )
}
export default Filter
